import React from 'react'
import { Table, Spinner } from 'react-bootstrap'
import '../kyc/SearchResultsTable.css'

type xpertConsumer = {
  firstname?: string
  surname?: string
  idno?: string
  passportnumber?: string
  name?: string
  enquiryID?: string
  enquiryResultID?: string
}

type Props = {
  //showProgress: boolean
  xpertConsumers: xpertConsumer[]

  setXpertConsumer: (consumer: xpertConsumer) => void
}

const TableDataConsumerTrace: React.FC<Props> = ({
  //showProgress,
  xpertConsumers,
  setXpertConsumer,
}) => (
  <div
    className="kyc-results-table-container"
    style={{ height: '300px', overflow: 'auto', marginTop: '10px' }}
  >
    <table>
      <thead>
        <tr>
          <td
            style={{
              backgroundColor: 'rgb(12, 135, 169)',
              color: 'rgb(255, 255, 255)',
              position: 'sticky',
              top: 0,
            }}
          >
            {/* {showProgress && (
              <>
                <Spinner
                  as="span"
                  size="sm"
                  animation="border"
                  variant="dark"
                  role="status"
                  aria-hidden="true"
                ></Spinner>
                <span> </span>
              </> 
            )}*/}
            ID/Passport
          </td>
          <td
            style={{
              backgroundColor: 'rgb(12, 135, 169)',
              color: 'rgb(255, 255, 255)',
              position: 'sticky',
              top: 0,
            }}
          >
            Name
          </td>
          <td
            style={{
              backgroundColor: 'rgb(12, 135, 169)',
              color: 'rgb(255, 255, 255)',
              position: 'sticky',
              top: 0,
            }}
          >
            Surname
          </td>
        </tr>
      </thead>
      <tbody>
        {xpertConsumers.map((consumer) => (
          <tr
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setXpertConsumer(consumer)
            }}
          >
            <td>{consumer.idno ? consumer.idno : consumer.passportnumber}</td>
            <td>{consumer.firstname}</td>
            <td>{consumer.surname}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)

export default TableDataConsumerTrace
